/* eslint-disable @typescript-eslint/no-explicit-any */
export const screenSizeType: string[] = [
  '(max-width: 768px)', // Mobile
  '(min-width: 768px) and (max-width: 992px)', // Tablet
  '(min-width: 992px)', // Large screen
];

export const screenSizeTypeObject: { [key: string]: string } = {
  '(max-width: 768px)': 'mobile',
  '(min-width: 768px) and (max-width: 992px)': 'tablet',
  '(min-width: 992px)': 'largeScreen',
}; // Large sc

export const maxSize = '100%';
export const modalSizeStyle = (style?: any | undefined) => ({
  height: '550px',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  ...style,
});

export const flexModalBody: any = { flex: 1, overflowY: 'auto' };
